<template lang="html">
  <div>
    <div class="divider"/>
    <div class="section has-text-centered" v-if="title">
      <h1 class="title">{{ title }}</h1>
      <h2 class="subtitle" v-if="subtitle">{{ subtitle }}</h2>

      <div class="subtitle small-menu is-centered">
        <ul>
          <li v-for="(item, index) in items" :class="{'is-active': index === activeItem}" :key="index">
            <a @click="activeItem = index">{{ item.title }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="columns is-multiline is-centered">
      <div class="column is-one-quarter" v-for="recipe in items[activeItem].items" :key="recipe.id">
        <div class="card recipe-preview">
          <div class="card-image">
            <a :href="`/recipe/${recipe.id}-${recipe.slug}/`">
              <figure class="image is-4by3">
                <picture>
                  <source :srcset="`https://res.cloudinary.com/digitalbits/image/upload/t_euromeal_preview_mobile/v1/euromeal/${recipe.image}`" media="(max-width: 768px)">
                  <source :srcset="`https://res.cloudinary.com/digitalbits/image/upload/t_euromeal_preview_tablet/v1/euromeal/${recipe.image}`" media="(max-width: 1199px)">
                  <source :srcset="`https://res.cloudinary.com/digitalbits/image/upload/t_euromeal_preview_desktop/v1/euromeal/${recipe.image}`" media="(min-width: 1200px)">
                  <img :src="`https://res.cloudinary.com/digitalbits/image/upload/t_euromeal_preview_desktop/v1/euromeal/${recipe.image}`">
                </picture>
              </figure>
            </a>
          </div>

          <div class="card-content">
            <a :href="`/recipe/${recipe.id}-${recipe.slug}/`">{{ recipe.name }}</a>
          </div>
        </div>

      </div>
    </div>

    <div class="has-text-centered">
      <a class="button is-primary is-handwritten is-large" :href="items[activeItem].href" v-if="items[activeItem].href">
        {{ showAllText }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {type: String, required: true},
    subtitle: {type: String, default: ''},
    items: {type: Array, default: () => ([])},
    showAllText: {type: String, required: true}
  },

  data(){
    return {
      activeItem: 0
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/ContentTabs.vue